import { render, staticRenderFns } from "./the-ota-detail.vue?vue&type=template&id=06f0928f&scoped=true&"
import script from "./the-ota-detail.vue?vue&type=script&lang=js&"
export * from "./the-ota-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0928f",
  null
  
)

export default component.exports